const limit = {
    RECENT_SEARCHES_LIMIT: 10,
    SEARCH_LIMIT: 10,
    VARIABLE_SEARCH_LIMIT: 100,
};
export default limit;

